import { useTranslation } from 'react-i18next';

/**
 * Hook to generate localized links
 * @returns {Function} Function that takes a path and returns localized path
 */
export const useLocalizedLink = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'tr';

  const getLocalizedPath = (path) => {
    if (!path || path === '/') {
      return currentLang === 'tr' ? '/' : '/en';
    }
    
    // If path already starts with /tr or /en, return as is
    if (path.match(/^\/(tr|en)\//) || path === '/tr' || path === '/en') {
      return path;
    }
    
    // Add language prefix for non-Turkish
    return currentLang === 'tr' ? path : `/${currentLang}${path}`;
  };

  return getLocalizedPath;
};

